import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTextInput from '../ui/CustomTextInput';
import ModalBody, { ModalProps } from './ModalBody';

interface DeleteModalProps extends ModalProps {
    deleteAction: () => void;
    title: string;
    itemName?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ deleteAction, open, handleClose, title, itemName }) => {
    const { t } = useTranslation();
    const [verificationText, setVerificationText] = useState('');

    return (
        <ModalBody
            title={title}
            subtitle={t('delete')}
            description={itemName}
            showSubmitButton={false}
            showSecondaryButton
            secondaryButtonText={t('delete')}
            open={open}
            handleClose={handleClose}
            onSecondaryAction={deleteAction}
            disableSecondaryButton={verificationText !== t('delete')}
        >
            <div className="w-300px pad-l-5px pad-r-5px pad-b-5px">{t('verificationDeleteText', { word: t('delete') })}</div>
            <CustomTextInput value={verificationText} onChange={(text) => setVerificationText(text)} />
        </ModalBody>
    );
};

export default DeleteModal;
